// `draftId == null` means the slot has no draft id assigned (e.g. switched off
// while idle). `draft === null` means the storage layer resolved with "no draft
// saved for this id". Both fall back to the plain Button branch.
export function hasDraft(draftId, draft) {
  return draftId != null && draft != null
}

// `draft === undefined` is the in-flight state set by useDraftProvider between
// the draftId change and the storage promise resolving — we surface that as a
// skeleton on the Button branch.
export function isDraftLoading(draftId, draft) {
  return draftId != null && draft === undefined
}
